import { Flex, Text } from "@chakra-ui/react";

export default function Settings() {
	return (
		<Flex direction='column' pt={'20px'}>
			<Text>Settings</Text>
		</Flex>
	)
}